define(['santa-components', 'prop-types', 'lodash', 'componentsCore'], function (santaComponents, PropTypes, _, componentsCore) {
    'use strict';

    function getIconName(isFullscreen) {
        return isFullscreen ? 'exitFullscreen' : 'fullscreen';
    }

    /**
     * @class components.MediaControlFullscreen
     * @extends {core.skinBasedComp}
     */

    return {
        displayName: 'MediaControlFullscreen',
        mixins: [componentsCore.mixins.skinBasedComp, componentsCore.mixins.createChildComponentMixin],

        propTypes: {
            style: PropTypes.object,
            playerId: PropTypes.string.isRequired,
            enableFullsceen: PropTypes.bool,
            svgPropsMapForMediaControls: PropTypes.object,
            fullscreen: PropTypes.bool,
            handleBehavior: santaComponents.santaTypesDefinitions.Behaviors.handleBehavior.isRequired
        },

        clickAction() {
            if (!this.props.enableFullsceen) {
                return;
            }
            this.props.handleBehavior({
                type: 'comp',
                targetId: this.props.playerId,
                name: this.props.fullscreen ? 'exitFullscreen' : 'enterFullscreen'
            });
        },

        /**
         * Get a vectorImage by current symbol name
         * @param {string} iconSymbolName
         * @returns {ReactCompositeComponent}
         */
        getIconComponent(iconSymbolName) {
            const iconProps = _.get(this.props.svgPropsMapForMediaControls, iconSymbolName);
            const props = _.assign({
                id: `${this.props.id}icon`,
                key: iconSymbolName,
                ref: 'icon',
                preserveViewBox: true
            }, iconProps);

            return this.createChildComponent(null, 'wysiwyg.viewer.components.VectorImage', 'icon', props);
        },

        getSkinProperties() {
            return {
                '': {
                    style: this.props.style
                },
                fullscreenButton: {
                    className: this.classSet({
                        'video-fullscreen': this.props.fullscreen,
                        'video-windowed': !this.props.fullscreen,
                        'disabled': !this.props.enableFullsceen
                    }),
                    onClick: this.clickAction
                },
                icon: this.getIconComponent(getIconName(this.props.fullscreen))
            };
        }
    };
});
